import InfiniteScroll from "react-infinite-scroller"
import { useSuspenseInfiniteQuery } from "source/registrations/utils/queryCache"
import { fetchStatements } from "../../queries"
import { Statement } from "../../types"
import { AlertMessage, Loading } from "source/shared/components"
import StatementDetails from "./StatementDetails"

interface StatementsListProps {
  activeYear: number | null
}

export default function StatementsList({ activeYear }: StatementsListProps) {
  const { data, isError, fetchNextPage, hasNextPage, isFetching } =
    useSuspenseInfiniteQuery({
      queryKey: ["Statements", activeYear],
      queryFn: ({ pageParam }) => {
        return fetchStatements({ year: activeYear, pageParam })
      },
      initialPageParam: 0,
      getNextPageParam: (lastPage) => lastPage.meta?.next?.offset,
    })
  const statements: Statement[] =
    data.pages.flatMap((page) => page.statements) || []
  const loadMore = () => !isFetching && fetchNextPage()

  return isError ? (
    <AlertMessage type="error" icon="general#exclamation-triangle">
      Something went wrong. Please try again.
    </AlertMessage>
  ) : (
    statements && (
      <InfiniteScroll
        hasMore={hasNextPage}
        loadMore={loadMore}
        loader={<Loading key="loading" />}
      >
        {statements.map((statement) => (
          <StatementDetails statement={statement} key={statement.id} />
        ))}
      </InfiniteScroll>
    )
  )
}
